import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[numberOnly]',
  standalone: false
})
export class NumberOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/\D*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
    if (initalValue.startsWith('0') && initalValue.length > 1) {
      event.target.value = initalValue.replace(/^0+/, '');
    }
  }
}
